export default "__VITE_ASSET__edMtgrRi__"